"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTimeForSegment = exports.getTimezoneForSegment = exports.getHourFormatForLocale = exports.getHourFormat = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const locale_1 = require("./locale");
const constants_1 = require("./constants");
const timezone_1 = require("./timezone");
const getHourFormat = (segment) => {
    if (segment === constants_1.Segment.Fixter_FR) {
        return "HH:mm" /* FR */;
    }
    if (segment === constants_1.Segment.Motrio_FR) {
        return "HH:mm" /* FR */;
    }
    return "h:mma" /* UK */;
};
exports.getHourFormat = getHourFormat;
const getHourFormatForLocale = (locale) => {
    if (locale === locale_1.Locale.FR_FR)
        return "HH:mm" /* FR */;
    return "h:mma" /* UK */;
};
exports.getHourFormatForLocale = getHourFormatForLocale;
const getTimezoneForSegment = (segment) => {
    if (segment === constants_1.Segment.Fixter_FR)
        return timezone_1.Timezone['Europe/Paris'];
    if (segment === constants_1.Segment.Motrio_FR)
        return timezone_1.Timezone['Europe/Paris'];
    return timezone_1.Timezone['Europe/London'];
};
exports.getTimezoneForSegment = getTimezoneForSegment;
const formatTimeForSegment = (date, segment, format) => {
    if ((0, dayjs_1.default)(date).isValid() === false)
        return date;
    switch (segment) {
        case constants_1.Segment.Fixter_UK:
            return (0, dayjs_1.default)(date)
                .locale('en-gb')
                .format(format || "h:mma" /* UK */);
        case constants_1.Segment.Fixter_FR:
            return (0, dayjs_1.default)(date)
                .locale('fr')
                .format(format || "HH:mm" /* FR */)
                .replace(/:/g, 'h');
        case constants_1.Segment.Motrio_FR:
            return (0, dayjs_1.default)(date)
                .locale('fr')
                .format(format || "HH:mm" /* FR */)
                .replace(/:/g, 'h');
        default:
            return (0, dayjs_1.default)(date).format(format || "h:mma" /* UK */);
    }
};
exports.formatTimeForSegment = formatTimeForSegment;
//# sourceMappingURL=time.js.map